module.exports = __webpack_public_path__ + "img/header-engagementRingsEntwined@2x.c4bf6d2.jpg";